export const ICON_SIZE = 10;
export const YOUTUBE_DESKTOP_HEIGHT = 322;
export const YOUTUBE_DESKTOP_WIDTH = 630;
export const YOUTUBE_MOBILE_HEIGHT = 172;
export const YOUTUBE_MOBILE_WIDTH = 337;
